import React, { Component } from 'react'

import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material'
import get from 'lodash/get'

import type { ColumnConfig } from './types'

type DescriptionListTableProps = {
  config: ColumnConfig[]
  data: Record<string, any>
  hover?: boolean
  title?: string
  titleCellStyle?: Record<string, any>
  valueCellStyle?: Record<string, any>
}

export default class DescriptionListTable extends Component<DescriptionListTableProps> {
  static defaultProps = {
    data: {},
    titleCellStyle: {},
    valueCellStyle: {},
    hover: false,
    title: '',
  }

  renderCell = (row: ColumnConfig) => {
    const { data } = this.props

    return row.render ? row.render(data) : get(data, row.field ?? '')
  }

  renderRow = (row: ColumnConfig, index: number) => {
    const { hover, titleCellStyle, valueCellStyle } = this.props

    return (
      <TableRow hover={hover} key={index}>
        <TableCell style={titleCellStyle}>
          <strong>{row.title}</strong>
        </TableCell>
        <TableCell style={valueCellStyle}>{this.renderCell(row)}</TableCell>
      </TableRow>
    )
  }

  render() {
    const { config, title } = this.props

    return (
      <div className="description-list-table">
        {title && (
          <Box component="h3" sx={{ color: '#646464', textAlign: 'center' }}>
            {title}
          </Box>
        )}
        <Table>
          <TableBody>{config.map(this.renderRow)}</TableBody>
        </Table>
      </div>
    )
  }
}
